/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const SearchResult = ({ item, readMore, isLast }) => {
    const {
        title,
        body,
    } = item.highlights;

    const {
        url,
        title: titleOriginal,
        intro,
    } = item.document;

    return (
        <a href={url} className={cx('card card--link', { 'is-last': isLast })}>
            <div className="card__content">
                <h2 className="card__title headline-3" dangerouslySetInnerHTML={{ __html: title || titleOriginal }} />
                <p className="card__text text" dangerouslySetInnerHTML={{ __html: body || intro }} />
                <div className="card__cta">
                    <span className="underline-link">{readMore}</span>
                </div>
            </div>
        </a>
    );
};

SearchResult.defaultProps = {
    isLast: false,
};

SearchResult.propTypes = {
    item: PropTypes.shape({}).isRequired,
    readMore: PropTypes.string.isRequired,
    isLast: PropTypes.bool,
};

export default SearchResult;
